import React from "react";
import {
  BoxButton,
  Typography,
  TypographyVariants,
} from "@trussle/external-components";
import "./styles.scss";
import { Link } from "gatsby";
import cn from "classnames";
import { ISplashPanelProps } from "../OriginalSplashPanel";
import { generateId } from "../../../../helpers/generateId";
import { ReplaceQueryParams } from "../../../ReplaceQueryParams";
import { transformRichText } from "../../../../helpers/richText";
import { RichText } from "../../../RichText";
import { PanelWrapper } from "../../../PanelWrapper";

export const BoxButtonsSplashPanel: React.FunctionComponent<
  ISplashPanelProps
> = ({
  title, headingType, mainContent, ctas, betterV2,
}) => {
  const contentRichTxt = mainContent && transformRichText(mainContent.raw);
  return (
    <PanelWrapper isBetterV2={betterV2}>
      <div className={cn("boxButtonSplashPanel", { secondary: betterV2 })}>
        <div className={cn("boxButtonSplashPanel__description", { secondary: betterV2 })}>
          {title && (
            <Typography
              classes={cn("boxButtonSplashPanel__title", { secondary: betterV2 })}
              variant={(headingType as TypographyVariants) || "h1"}
              {...(title && {
                id: generateId(title),
              })}
            >
              <ReplaceQueryParams>{title}</ReplaceQueryParams>
            </Typography>
          )}
          {mainContent && (
            <div className={cn("boxButtonsStyledRichTextContainer", { secondary: betterV2 })}>
              <RichText content={contentRichTxt} />
            </div>
          )}
        </div>
        <div className={cn("boxButtonSplashPanel--boxButtons", { secondary: betterV2 })}>
          { ctas?.map((button) => (
            <Link key={button.title} to={button.url} className="boxButtonSplashPanel--link">
              <BoxButton text={button.title} variant={betterV2 ? "secondary" : "primary"} />
            </Link>
          )) }
        </div>
      </div>
    </PanelWrapper>
  );
};
